
export const fetchClientnameFrompassport = async (passport, setNotification) => {
    const token = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_API_URL;
    try {
        const response = await fetch(`${apiUrl}/api/client/${passport}/clientname`, {
            headers: { 'Authorization': `Bearer ${token}`},
        });

        if (response.status === 404) {
            setNotification(`لا يوجد حريف تحت رقم جواز السفر ${passport}`);
            return ;
        }

        if (!response.ok) {
            return ;
        }
        const result = await response.json();
        if (result && result.clientName) {
            return result.clientName;
        } else {
            setNotification(`لا يوجد اسم حريف مرتبط بجواز السفر ${passport}`);
            return ;
        }
    } catch (error) {
        console.error('Error fetching client name:', error);
        return ;
    }
};
